import { call, put, SagaGenerator, takeMaybe } from "typed-redux-saga";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { LoggerFactory } from "@com.mgmtp.a12.utils/utils-logging";

import { reloadTaskAndAntragActivity } from "../../../utilities/workflowUtils";
import { fetchWrapper } from "../../../app/sagas/fetchSagaFactory";
import { openTaskDocument } from "../../processOverview/store/actions";

import { EldoradoCancelArchivePayload } from "../actions";

const logger = LoggerFactory.getLogger("cancelEldoradoArchiveTask");

export function* cancelEldoradoArchiveTask(payload: EldoradoCancelArchivePayload): SagaGenerator<void> {
	const {
		documentReference,
		activityId,
		implicit,
		closeActivity,
		reopenWorkflowsActivities,
		archiveSystem = "eldorado"
	} = payload;
	if (activityId && closeActivity) {
		if (implicit) {
			yield* put(ActivityActions.cancel({ activityId }));
		} else {
			yield* put(ActivityActions.cancelRequested({ activityIds: [activityId] }));
			const isCancelVeto = (yield* takeMaybe(ActivityActions.responseCancelConfirmation)).payload.veto;
			if (isCancelVeto) {
				return;
			}
		}
	}

	if (documentReference && archiveSystem === "eldorado") {
		try {
			yield* call(fetchWrapper, cancelArchivalRequest(documentReference));
		} catch (e) {
			logger.error("Failed to cancel archiving for document", documentReference, e);
		}
	}

	if (documentReference && reopenWorkflowsActivities) {
		yield* put(openTaskDocument({ instance: documentReference }));
	} else {
		yield* call(reloadTaskAndAntragActivity);
	}
}

export function cancelArchivalRequest(documentReference: string) {
	return {
		relativeUrl: `/eldorado/cancelArchiving?documentReference=${documentReference}`,
		method: "POST"
	};
}
